import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { loadPeriodos } from '../../store/actions/Periodos';

import Grid from '@material-ui/core/Grid';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import LaptopMacIcon from '@material-ui/icons/LaptopMac';
import DescriptionIcon from '@material-ui/icons/Description';
import VpnKeyOutlinedIcon from '@material-ui/icons/VpnKeyOutlined';
import HighlightOffOutlinedIcon from '@material-ui/icons/HighlightOffOutlined';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import PostAddIcon from '@material-ui/icons/PostAdd';
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';

import { makeStyles } from '@material-ui/core/styles';

import CandidatoService from '../../services/Candidato';
import InscricaoService from '../../services/Inscricao';
import EnumService from '../../services/Enum';
import { errors } from '../../services/API';

import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import Title from '../../components/Title/Title';
import Table from '../../components/Table/Table';
import Toast from '../../components/Toast/Toast';
import {
    verifyPagingAndSorting,
    PAGE,
    SIZE,
    ASC,
    TOTAL_ELEMENTS,
    TOTAL_PAGES,
} from '../../components/Table/Utils';

import { patternEnum } from '../../variables/Enums/Enum';

import CandidatoFilter from '../../forms/Candidato/CandidatoFilter';
import { ButtonExport } from '../../forms/Buttons/ButtonsExport';
import DialogChangePassword from '../../forms/Dialog/DialogChangePassword';
import { DialogRemove as DialogRemoverInscricao } from '../../forms/Dialog/DialogRemove';
import { DialogReabrirInscricao } from '../../forms/Dialog/DialogReabrirInscricao';

import { verifyPersistence, removePagingAndSorting } from '../../helper/PaginationHelper';

import { isAdministradorOuCentral, isCoordenadorOuApoioSecretarial } from '../../security/AuthorizedFunction';

import {
    isInscricoesAbertas,
    getPeriodoDeInscricaoFormatado
} from '../../helper/ContextHelper';

import { Layout } from '../../layouts/private/Private';
import { cpfMask } from '../../helper/MaskHelper';

export const useStyles = makeStyles(theme => ({
    body: {
        margin: theme.spacing(3, 0),
    },
}));

export const patternNome = (nomeExibicao, nomeSocial, nome) => {
    return (
        <>
            {nomeExibicao} {nomeSocial && <span style={{ display: "block", fontSize: 11, color: "#999" }}>{nome}</span>}
        </>
    )
}

export class Candidato extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: PAGE,
            size: SIZE,
            totalElements: TOTAL_ELEMENTS,
            totalPages: TOTAL_PAGES,
            sort: [{ orderBy: 'nome', order: ASC }],
            defaultOrderBy: 'nome',
            filtered: false,
            filters: [],
            candidatos: [],
            loading: true,
            sendToCandidatos: [],
            loadingButtonSave: false,
            jaFezBuscaDaUrl: false,
            optionsStatusCandidato: [],
        }

        this.state = verifyPersistence(this.state, this.props.location);
    }

    setToast = t => this.Toast = t;
    setCandidatoFilter = f => this.CandidatoFilter = f;
    setDialogRemoverInscricao = r => this.DialogRemoverInscricao = r;
    setDialogChangePassword = f => this.DialogChangePassword = f;
    setDialogReabrirInscricao = r => this.DialogReabrirInscricao = r;

    labelSemPermissao = "Você não tem permissão para fazer isso";

    isCandidaturaFinalizada = (id) => {
        const candidato = this.state.candidatos.find(c => c.id === id);
        return candidato.candidaturaFinalizada ? true : false;
    }

    comProvaVinculada = (id) => {
        const candidato = this.state.candidatos.find(c => c.id === id);
        return candidato.codigoProvaVinculada ? true : false;
    }

    handleExportPlan = (tipoPlanilha) => {

        if (tipoPlanilha === 'CANDIDATOS') {
            this.CandidatoFilter.setState({ filter: true, exportPlan: true }, () => this.CandidatoFilter.handleFilterApply());
        }

        if (tipoPlanilha === 'LOCAIS_PROVA') {
            this.CandidatoFilter.setState({ filter: true, exportarPlanLocalProva: true }, () => this.CandidatoFilter.handleFilterApply());
        }

        this.Toast.setState({
            message: {
                message: "A Planilha está sendo gerada para Exportação.",
                type: 'info',
                open: true,
                loading: true,
                autoHide: false,
            }
        })
    }

    handleEditClick = id => {
        const candidato = this.state.candidatos.find(c => c.id === id);
        this.props.history.push({
            pathname: `/admin/inscricao/${candidato.cpf}/editar`,
            state: {
                history: {
                    path: `/admin/candidatos`,
                    state: this.state,
                }
            }
        });
    }

    handleAddProva = id => {
        this.props.history.push({
            pathname: `/admin/candidatos/${id}/prova/adicionar`,
            state: {
                history: {
                    path: `/admin/candidatos`,
                    state: this.state,
                }
            }
        });
    }

    handleOpenAtualizarSenhaClick = id => {
        const candidato = this.state.candidatos.find(c => c.id === id);
        this.DialogChangePassword.setState({ open: true, id: candidato.id, login: candidato.cpf });
    }

    handleRemoverInscricao = id => {
        const candidato = this.state.candidatos.find(c => c.id === id);
        this.DialogRemoverInscricao.setState({
            dialog: {
                open: true,
                title: `Deseja Remover a Inscrição do Candidato ${candidato.nome} - ${candidato.codigo} ?`,
                text: `A Inscrição e o Cadastro deste Candidato serão Removidos. O Candidato Poderá se Inscrever Novamente com Outras Informações.`,
                id: id,
                loading: false,
            }
        });
    }

    handleRemoverInscricaoConfirm = (id) => {
        this.DialogRemoverInscricao.loading();

        InscricaoService.remove(id)
            .then(res => {
                this.Toast.setState({
                    message: {
                        message: "A Inscrição foi Removida com Sucesso.",
                        type: 'success',
                        open: true
                    }
                })
            })
            .catch(error => {
                const e = errors(error);
                this.Toast.setState({
                    message: {
                        message: e.message,
                        type: e.type,
                        open: true
                    }
                })
            })
            .finally(() => {
                this.DialogRemoverInscricao.close();
                this.loadData();
            });
    }

    handleViewDashboard = id => {
        const candidato = this.state.candidatos.find(c => c.id === id);
        this.props.history.push({
            pathname: `/admin/inicio`,
            state: {
                candidato: {
                    id: candidato.id
                }
            }
        });
    }

    handleViewReceipt = (id) => {
        const candidato = this.state.candidatos.find(c => c.id === id);
        this.props.history.push({
            pathname: `/admin/inscricao/${candidato.id}/comprovante`,
            state: {
                history: {
                    path: `/admin/candidatos`,
                    state: this.state,
                }
            }
        });
    }

    handleReabrirInscricao = id => {
        const candidato = this.state.candidatos.find(c => c.id === id);

        if (candidato.pagamentoEmAndamento) {
            this.Toast.setState({
                message: {
                    message: "A Inscrição não pode ser Reaberta pois o Candidato possui Pagamento em Andamento.",
                    type: 'warning',
                    open: true
                }
            })
            return;
        }

        this.DialogReabrirInscricao.setState({
            dialog: {
                open: true,
                title: `Deseja Reabrir a Inscrição do Candidato ${candidato.nomeExibicao} - ${candidato.codigo} ?`,
                text: (
                    <>
                        A Inscrição deste Candidato será Reaberta. Após Alterar os Dados, o Candidato Precisará Finalizar Novamente sua Inscrição no período de{' '}
                        <b>{getPeriodoDeInscricaoFormatado(this.props.contexts)}</b>.{' '}
                        Caso não Finalize, será Desconsiderado nas Etapas Seguintes.
                        <br /><br />
                        Tem Certeza de que Deseja Reabrir esta Inscrição?
                    </>
                ),
                id: id,
                loading: false,
                severity: 'warning',
            }
        });
    }

    handleReabrirInscricaoConfirm = (id) => {
        this.DialogReabrirInscricao.loading();

        CandidatoService.reabrirInscricao(id)
            .then(res => {
                this.Toast.setState({
                    message: {
                        message: "A Inscrição foi Reaberta com Sucesso.",
                        type: 'success',
                        open: true
                    }
                })
            })
            .catch(error => {
                const e = errors(error);
                this.Toast.setState({
                    message: {
                        message: e.message,
                        type: e.type,
                        open: true
                    }
                })
            })
            .finally(() => {
                this.DialogReabrirInscricao.close();
                this.loadData();
            });
    }

    loadData = async () => {
        this.props.loadPeriodos();

        const statusCandidato = await EnumService.listarStatusCandidato().then(res => res.data);
        this.setState({ ...this.state, optionsStatusCandidato: [...statusCandidato] });

        let filters = verifyPagingAndSorting(this.state);

        this.setState({
            filters: [...filters],
            filtered: true,
            loading: true
        });

        if (!this.state.jaFezBuscaDaUrl) {
            const parseFilters = queryString.parse(this.props.location.search);

            if (parseFilters.status) filters.push({ field: 'status', value: parseFilters.status })
            if (parseFilters.inep) filters.push({ field: 'inep', value: parseFilters.inep })
            if (parseFilters.depAdmin) filters.push({ field: 'dependenciaAdministrativa', value: parseFilters.depAdmin })
            if (parseFilters.uf) filters.push({ field: 'ufProvaConfirmado', value: parseFilters.uf })
            if (parseFilters.municipio) filters.push({ field: 'municipioProvaConfirmado', value: parseFilters.municipio })
            if (parseFilters.dataFinalizacaoInscricao) filters.push({ field: 'dataFinalizacaoInscricao', value: parseFilters.dataFinalizacaoInscricao })
            if (parseFilters.dataInicioInscricao) filters.push({ field: 'dataInicioInscricao', value: parseFilters.dataInicioInscricao })
            if (parseFilters.comEscolaSelecionada) filters.push({ field: 'comEscolaSelecionada', value: parseFilters.comEscolaSelecionada })
            if (parseFilters.comLocalProvaSelecionado) filters.push({ field: 'comLocalProvaSelecionado', value: parseFilters.comLocalProvaSelecionado })

            this.setState({ jaFezBuscaDaUrl: true });
        }

        await CandidatoService.filters(filters)
            .then(res => {
                if (res.data.content) {
                    this.setState({
                        ...this.state,
                        candidatos: [...res.data.content],
                        page: res.data.number,
                        size: res.data.size,
                        totalElements: res.data.totalElements,
                        totalPages: res.data.totalPages,
                        loading: false,
                    });

                    this.CandidatoFilter.handleFilterPersistence(filters);
                } else {
                    this.setState({
                        ...this.state,
                        candidatos: [],
                        page: PAGE,
                        size: SIZE,
                        totalElements: TOTAL_ELEMENTS,
                        totalPages: TOTAL_PAGES,
                        loading: false,
                    });
                }
            })
            .catch(error => {
                const e = errors(error);
                this.Toast.setState({
                    message: {
                        message: e.message,
                        type: e.type,
                        open: true
                    }
                })

                this.setState({ loading: false });
            })
    }

    filterData = (filters, isActive = true) => this.setState({ filtered: isActive, filters: [...removePagingAndSorting(filters)] }, () => this.loadData());
    handlePage = page => this.setState({ page: page }, () => this.filterData(this.state.filters));
    handleRowsPerPage = (size, page) => this.setState({ size: size, page: page }, () => this.filterData(this.state.filters));
    handleSort = (orderBy, order) => {
        if (this.state.sort.find(s => s.orderBy === orderBy)) {
            let newSort = this.state.sort.filter(s => s.orderBy !== orderBy);
            newSort.splice(this.state.sort.indexOf(this.state.sort.find(s => s.orderBy === orderBy)), 0, { orderBy: orderBy, order: order })
            this.setState({ ...this.state, sort: [...newSort], filtered: true });
        } else {
            this.setState({ ...this.state, sort: [...this.state.sort.filter(s => s.orderBy !== orderBy), { orderBy: orderBy, order: order }], filtered: true });
        }
    }
    handleClearSort = (orderBy) => {
        this.setState({ ...this.state, filtered: true, sort: orderBy ? [...this.state.sort.filter(s => s.orderBy !== orderBy)] : [{ orderBy: this.state.defaultOrderBy, order: ASC }] });
    };
    handleTotalPages = () => this.state.totalPages;
    handleTotalElements = () => this.state.totalElements;
    handleFilterPersistence = () => this.CandidatoFilter ? this.CandidatoFilter.state ? this.CandidatoFilter.handleFilterPersistence(this.state.filters) : null : null;

    componentDidMount() { this.loadData(); }

    carregarNome = (id) => {
        const candidato = this.state.candidatos.find(c => c.id === id);
        return patternNome(candidato.nomeExibicao, candidato.nomeSocial, candidato.nome);
    }

    patternCodigo = (id) => {
        const candidato = this.state.candidatos.find(c => c.id === id);
        return <> 
            {candidato.codigo}

            {candidato.codigoProvaVinculada &&
                <Tooltip title={`Com Prova Vinculada (${candidato.codigoProvaVinculada})`} TransitionComponent={Zoom}>
                    <span style={{ verticalAlign: "middle", margin: "0px 4px", padding: 4, borderRadius: 20, backgroundColor: "#02b82a", color: "white", display: 'inline-block', fontSize: 10 }}><center> </center></span>
                </Tooltip>
            }

            {candidato.codigoProva && candidato.codigoProvaVinculada && candidato.codigoProva !== candidato.codigoProvaVinculada ?
                <>
                    <span style={{ display: "block", fontSize: 11, color: "#999", textDecoration: "line-through" }}>{candidato.codigoProva}</span>
                    <span style={{ display: "block", fontSize: 11, color: "#999" }}>{candidato.codigoProvaVinculada}</span>
                </>
            :
                <span style={{ display: "block", fontSize: 11, color: "#999" }}>{candidato.codigoProva}</span>
            }
        </>
    }

    render() {
        const pageName = 'Candidatos';
        const links = [
            {
                path: null,
                name: 'Administração'
            }
        ];

        const columns = [
            { label: '#', name: 'id', func: null, key: true, hidden: true },
            { label: 'Código', name: 'codigo', func: (value, id) => this.patternCodigo(id), key: false },
            { label: 'Nome', name: 'nome', func: (value, id) => this.carregarNome(id), key: false },
            { label: 'CPF', name: 'cpf', func: cpfMask, key: false },
            { label: 'Status', name: 'status', func: (value, id) => patternEnum(value, this.state.optionsStatusCandidato), key: false, ordering: false },
            { label: 'Município / UF', name: 'endereco', func: (value) => `${value.municipio.nome} / ${value.municipio.uf.id}`, key: false, ordering: false },
            { label: 'Município / UF Local de Realização de Prova', name: 'localProvaFinal', func: (value) => value ? `${value.nome} / ${value.uf.id}` : `--`, key: false, ordering: false },
        ];

        const actions = [
            {
                name: () => isAdministradorOuCentral() ? "Reabrir Inscrição" : this.labelSemPermissao,
                func: this.handleReabrirInscricao,
                icon: <LockOpenIcon />,
                disabled: (id) => {
                    const c = this.state.candidatos.find(c => c.id === id);
                    return !isAdministradorOuCentral() || !isInscricoesAbertas(this.props.contexts) || (c.precisaRealizarPagamento && (c.pagamentoEmAndamento || c.pagamentoConfirmado)) || !c.dataFinalizacaoInscricao;
                }
            },
            {
                name: () => isAdministradorOuCentral() ? "Ver/Editar Inscrição" : this.labelSemPermissao,
                func: this.handleEditClick,
                icon: <EditOutlinedIcon />,
                disabled: () => !isAdministradorOuCentral(),
            },
            {
                name: () => isAdministradorOuCentral() ? "Adicionar Prova" : this.labelSemPermissao,
                func: this.handleAddProva,
                icon: <PostAddIcon />,
                disabled: (id) => !isAdministradorOuCentral() || this.comProvaVinculada(id),
            },
            {
                name: () => "Alterar Senha",
                func: this.handleOpenAtualizarSenhaClick,
                icon: <VpnKeyOutlinedIcon />,
                disabled: () => false,
            },
            {
                name: (id) => this.isCandidaturaFinalizada(id) ? "Ver Comprovante de Inscrição" : this.labelSemPermissao,
                func: this.handleViewReceipt,
                icon: <DescriptionIcon />,
                disabled: (id) => !this.isCandidaturaFinalizada(id),
            },
            {
                name: () => isAdministradorOuCentral() ? "Ver Dashboard" : this.labelSemPermissao,
                func: this.handleViewDashboard,
                icon: <LaptopMacIcon />,
                disabled: () => !isAdministradorOuCentral(),
            },
            {
                name: () => isAdministradorOuCentral() ? "Remover Inscrição" : this.labelSemPermissao,
                func: this.handleRemoverInscricao,
                icon: <HighlightOffOutlinedIcon />,
                disabled: () => !isAdministradorOuCentral(),
                color: "secondary"
            },
        ];

        const actionsCoord = [
            {
                name: () => "Alterar Senha",
                func: this.handleOpenAtualizarSenhaClick,
                icon: <VpnKeyOutlinedIcon />,
                disabled: () => false,
            },
            {
                name: (id) => this.isCandidaturaFinalizada(id) ? "Ver Comprovante de Inscrição" : this.labelSemPermissao,
                func: this.handleViewReceipt,
                icon: <DescriptionIcon />,
                disabled: (id) => !this.isCandidaturaFinalizada(id),
            },
        ];

        this.handleFilterPersistence();

        return (
            <Layout>
                <Toast parentRef={this.setToast} />
                <Grid container >
                    <Grid item xs={12}>
                        <Breadcrumbs links={links} active={pageName} />
                    </Grid>
                </Grid>
                <Title>{pageName}</Title>

                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <CandidatoFilter
                            parentRef={this.setCandidatoFilter}
                            handleFilterChange={this.filterData}
                        />

                        <div style={{ display: 'flex', alignItems: 'center', marginTop: 16, gap: 8 }}
                        >
                            {(isAdministradorOuCentral() && this.state.filters.length > 3) && (
                                <ButtonExport
                                    title="Exportar Planilha"
                                    onClick={() => this.handleExportPlan("CANDIDATOS")}                                    
                                    noGrid
                                />
                            )}

                            {isAdministradorOuCentral() && (
                                <ButtonExport
                                    title="Exportar Planilha de Locais de Prova para Gráfica"
                                    onClick={() => this.handleExportPlan("LOCAIS_PROVA")}                                    
                                    noGrid
                                />
                            )}
                        </div>

                        <Table
                            columns={columns}
                            tableData={this.state.candidatos}
                            actions={isCoordenadorOuApoioSecretarial() ? actionsCoord : actions}
                            groupActions={true}
                            page={this.state.page}
                            handlePage={this.handlePage}
                            handleTotalPages={this.handleTotalPages}
                            handleTotalElements={this.handleTotalElements}
                            rowsPerPage={this.state.size}
                            handleRowsPerPage={this.handleRowsPerPage}
                            sort={this.state.sort}
                            handleSort={this.handleSort}
                            handleClearSort={this.handleClearSort}
                            loading={this.state.loading}
                        />
                    </Grid>
                </Grid>

                {(isAdministradorOuCentral() || isCoordenadorOuApoioSecretarial()) &&
                    <DialogChangePassword
                        parentRef={this.setDialogChangePassword}
                        handleAtualizarSenha={CandidatoService.atualizarSenha}
                    />
                }

                {isAdministradorOuCentral() &&
                    <>
                        <DialogRemoverInscricao
                            parentRef={this.setDialogRemoverInscricao}
                            handleConfirm={this.handleRemoverInscricaoConfirm}
                        />

                        <DialogReabrirInscricao
                            parentRef={this.setDialogReabrirInscricao}
                            handleConfirm={this.handleReabrirInscricaoConfirm}
                        />
                    </>
                }
            </Layout>
        )
    }
}

const mapStateToProps = state => ({ contexts: state.periodos });
const mapDispatchToProps = dispatch => (bindActionCreators({ loadPeriodos }, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Candidato));